export default "__VITE_ASSET__By4zC0Zp__"